import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const API = '';
const DB_TYPES = [
  { value: 'postgresql', label: 'PostgreSQL', port: 5432, color: '#336791' },
  { value: 'mysql', label: 'MySQL', port: 3306, color: '#4479A1' },
  { value: 'mssql', label: 'MS SQL Server', port: 1433, color: '#CC2927' },
  { value: 'hana', label: 'SAP HANA', port: 30015, color: '#0FAAFF' },
];

function ConnForm({ title, config, setConfig, color }) {
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const testConn = async () => {
    setTesting(true); setTestResult(null);
    try {
      const res = await fetch(`${API}/migrate/test-connection`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(config) });
      const data = await res.json();
      setTestResult(data);
    } catch (e) { setTestResult({ success: false, message: '서버 오류' }); }
    setTesting(false);
  };

  const updateType = (type) => {
    const db = DB_TYPES.find(d => d.value === type);
    setConfig({ ...config, type, port: db?.port || '' });
  };

  return (
    <div style={{ background: 'white', borderRadius: 8, border: '2px solid ' + color, padding: 16, flex: 1 }}>
      <h3 style={{ marginTop: 0, fontSize: 15, color }}>{title}</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <div style={{ gridColumn: '1/3' }}>
          <label style={{ fontSize: 11, color: '#888' }}>DB 종류</label>
          <select value={config.type} onChange={e => updateType(e.target.value)}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13 }}>
            {DB_TYPES.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#888' }}>Host</label>
          <input value={config.host} onChange={e => setConfig({...config, host: e.target.value})}
            placeholder="localhost" style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#888' }}>Port</label>
          <input value={config.port} onChange={e => setConfig({...config, port: e.target.value})}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#888' }}>Database</label>
          <input value={config.database} onChange={e => setConfig({...config, database: e.target.value})}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#888' }}>User</label>
          <input value={config.user} onChange={e => setConfig({...config, user: e.target.value})}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
        </div>
        <div style={{ gridColumn: '1/3' }}>
          <label style={{ fontSize: 11, color: '#888' }}>Password</label>
          <input type="password" value={config.password} onChange={e => setConfig({...config, password: e.target.value})}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 10 }}>
        <button onClick={testConn} disabled={testing}
          style={{ padding: '6px 16px', background: color, color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, fontWeight: 'bold' }}>
          {testing ? '테스트중...' : '연결 테스트'}
        </button>
        {testResult && (
          <span style={{ fontSize: 12, color: testResult.success ? '#2e7d32' : '#c62828', fontWeight: 'bold' }}>
            {testResult.success ? 'OK' : testResult.message}
          </span>
        )}
      </div>
    </div>
  );
}

function MigrateAgent() {
  const navigate = useNavigate();
  const [source, setSource] = useState({ type: 'postgresql', host: '', port: 5432, database: '', user: '', password: '' });
  const [target, setTarget] = useState({ type: 'postgresql', host: '', port: 5432, database: '', user: '', password: '' });
  const [schema, setSchema] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selTables, setSelTables] = useState([]);
  const [selViews, setSelViews] = useState([]);
  const [selProcs, setSelProcs] = useState([]);
  const [migrateData, setMigrateData] = useState(true);
  const [migrating, setMigrating] = useState(false);
  const [progress, setProgress] = useState(null);
  const pollRef = useRef(null);

  const loadSchema = async () => {
    setLoading(true); setSchema(null);
    try {
      const res = await fetch(`${API}/migrate/schema`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(source) });
      const data = await res.json();
      if (data.error) alert(data.error);
      else { setSchema(data); setSelTables(data.tables || []); setSelViews(data.views || []); setSelProcs(data.procedures || []); }
    } catch (e) { alert('스키마 조회 실패'); }
    setLoading(false);
  };

  const startMigration = async () => {
    if (!window.confirm(`${selTables.length}개 테이블, ${selViews.length}개 뷰, ${selProcs.length}개 프로시저를 마이그레이션합니다. 계속하시겠습니까?`)) return;
    setMigrating(true); setProgress(null);
    try {
      const res = await fetch(`${API}/migrate/start`, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ source, target, options: { tables: selTables, views: selViews, procedures: selProcs, migrate_data: migrateData } })
      });
      const data = await res.json();
      const mid = data.migration_id;
      pollRef.current = setInterval(async () => {
        try {
          const pr = await fetch(`${API}/migrate/progress/${mid}`);
          const pg = await pr.json();
          setProgress(pg);
          if (pg.status === 'done') { clearInterval(pollRef.current); setMigrating(false); }
        } catch (e) {}
      }, 2000);
    } catch (e) { alert('시작 실패'); setMigrating(false); }
  };

  useEffect(() => () => clearInterval(pollRef.current), []);

  const toggle = (arr, set, item) => set(prev => prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]);

  const srcColor = DB_TYPES.find(d => d.value === source.type)?.color || '#333';
  const tgtColor = DB_TYPES.find(d => d.value === target.type)?.color || '#333';

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      <div style={{ background: 'linear-gradient(135deg, #1a237e, #283593, #3949ab)', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 16, boxShadow: '0 2px 12px rgba(26,35,126,0.3)' }}>
        <button onClick={() => navigate('/')} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', width: 36, height: 36, borderRadius: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12 4l-6 6 6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </button>
        <div>
          <div style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>DB 마이그레이션 에이전트</div>
          <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12 }}>AI 기반 데이터베이스 자동 마이그레이션 (테이블, 뷰, 프로시저, 데이터)</div>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '24px auto', padding: '0 20px 40px' }}>
        {/* 1. 연결 설정 */}
        <div style={{ display: 'flex', gap: 16, marginBottom: 20, alignItems: 'stretch' }}>
          <ConnForm title="Source (현재 DB)" config={source} setConfig={setSource} color={srcColor} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button onClick={() => { const tmp = {...source}; setSource({...target}); setTarget(tmp); setSchema(null); }}
              title="Source ↔ Target 교체"
              style={{ width: 48, height: 48, borderRadius: '50%', border: '2px solid #3949ab', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#3949ab'; e.currentTarget.querySelector('svg').style.stroke = 'white'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'white'; e.currentTarget.querySelector('svg').style.stroke = '#3949ab'; }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: '#3949ab', strokeWidth: 2.5, strokeLinecap: 'round', strokeLinejoin: 'round' }}>
                <path d="M7 16l-4-4 4-4"/><path d="M17 8l4 4-4 4"/><path d="M3 12h18"/>
              </svg>
            </button>
          </div>
          <ConnForm title="Target (대상 DB)" config={target} setConfig={setTarget} color={tgtColor} />
        </div>

        {/* 2. 스키마 조회 */}
        <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', padding: 16, marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0, fontSize: 15, color: '#1a237e' }}>소스 DB 스키마 분석</h3>
            <button onClick={loadSchema} disabled={loading}
              style={{ padding: '8px 20px', background: loading ? '#ccc' : '#3949ab', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 'bold' }}>
              {loading ? '분석중...' : '스키마 조회'}
            </button>
          </div>

          {schema && (
            <div style={{ marginTop: 16 }}>
              <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                <span style={{ padding: '4px 12px', background: '#e8eaf6', borderRadius: 12, fontSize: 12, color: '#1a237e', fontWeight: 'bold' }}>테이블 {schema.tables.length}개</span>
                <span style={{ padding: '4px 12px', background: '#e3f2fd', borderRadius: 12, fontSize: 12, color: '#1565c0', fontWeight: 'bold' }}>뷰 {schema.views.length}개</span>
                <span style={{ padding: '4px 12px', background: '#fce4ec', borderRadius: 12, fontSize: 12, color: '#c62828', fontWeight: 'bold' }}>프로시저 {schema.procedures.length}개</span>
              </div>

              {/* 선택 영역 */}
              {[{ label: '테이블', items: schema.tables, sel: selTables, setSel: setSelTables, color: '#1a237e' },
                { label: '뷰', items: schema.views, sel: selViews, setSel: setSelViews, color: '#1565c0' },
                { label: '프로시저', items: schema.procedures, sel: selProcs, setSel: setSelProcs, color: '#c62828' }
              ].filter(s => s.items.length > 0).map(section => (
                <div key={section.label} style={{ marginBottom: 12 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 13, fontWeight: 'bold', color: section.color }}>{section.label} ({section.sel.length}/{section.items.length})</span>
                    <button onClick={() => section.setSel(section.sel.length === section.items.length ? [] : [...section.items])}
                      style={{ padding: '2px 10px', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: 4, cursor: 'pointer', fontSize: 11 }}>
                      {section.sel.length === section.items.length ? '전체 해제' : '전체 선택'}
                    </button>
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, maxHeight: 120, overflowY: 'auto' }}>
                    {section.items.map(item => (
                      <button key={item} onClick={() => toggle(section.sel, section.setSel, item)}
                        style={{
                          padding: '3px 10px', borderRadius: 4, fontSize: 11, fontFamily: 'monospace', cursor: 'pointer',
                          background: section.sel.includes(item) ? section.color : '#f5f5f5',
                          color: section.sel.includes(item) ? 'white' : '#333',
                          border: '1px solid ' + (section.sel.includes(item) ? section.color : '#ddd'),
                        }}>{item}</button>
                    ))}
                  </div>
                </div>
              ))}

              {/* 옵션 + 실행 */}
              <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginTop: 16, padding: '12px 0', borderTop: '1px solid #eee' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
                  <input type="checkbox" checked={migrateData} onChange={e => setMigrateData(e.target.checked)} />
                  데이터도 이관
                </label>
                {source.type !== target.type && (
                  <span style={{ fontSize: 12, padding: '3px 10px', background: '#fff3e0', color: '#e67700', borderRadius: 8 }}>
                    AI 자동 타입/문법 변환 적용
                  </span>
                )}
                <div style={{ flex: 1 }} />
                <button onClick={startMigration} disabled={migrating || (selTables.length + selViews.length + selProcs.length) === 0}
                  style={{
                    padding: '10px 32px', background: migrating ? '#ccc' : 'linear-gradient(135deg, #1a237e, #3949ab)',
                    color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 15, fontWeight: 'bold',
                  }}>
                  {migrating ? '마이그레이션 진행중...' : '마이그레이션 시작'}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* 3. 진행률 + 결과 */}
        {progress && (
          <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', overflow: 'hidden' }}>
            {/* 프로그레스 */}
            <div style={{ padding: 20, borderBottom: '1px solid #eee' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ fontWeight: 'bold', color: '#1a237e', fontSize: 16 }}>
                  {progress.status === 'done' ? '마이그레이션 완료' : progress.current}
                </span>
                <span style={{ fontSize: 28, fontWeight: 'bold', color: progress.status === 'done' ? '#2e7d32' : '#3949ab' }}>{progress.percent}%</span>
              </div>
              <div style={{ height: 10, background: '#e8eaf6', borderRadius: 5, overflow: 'hidden' }}>
                <div style={{ height: '100%', background: progress.status === 'done' ? 'linear-gradient(90deg,#2e7d32,#43a047)' : 'linear-gradient(90deg,#1a237e,#3949ab)', borderRadius: 5, transition: 'width 0.5s', width: progress.percent + '%' }} />
              </div>
              <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>{progress.done_steps} / {progress.total_steps} 단계 완료</div>
            </div>

            {/* 결과 리포트 */}
            {progress.status === 'done' && (
              <div style={{ padding: 20 }}>
                <h3 style={{ margin: '0 0 12px', fontSize: 15, color: '#1a237e' }}>결과 리포트</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 16 }}>
                  {[
                    { label: '테이블', count: progress.results.tables.length, color: '#1a237e', bg: '#e8eaf6' },
                    { label: '데이터', count: progress.results.data.length, color: '#2e7d32', bg: '#e8f5e9' },
                    { label: '뷰', count: progress.results.views.length, color: '#1565c0', bg: '#e3f2fd' },
                    { label: '프로시저', count: progress.results.procedures.length, color: '#c62828', bg: '#fce4ec' },
                  ].map(s => (
                    <div key={s.label} style={{ padding: 12, background: s.bg, borderRadius: 8, textAlign: 'center' }}>
                      <div style={{ fontSize: 24, fontWeight: 'bold', color: s.color }}>{s.count}</div>
                      <div style={{ fontSize: 12, color: '#666' }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* 상세 */}
                {progress.results.tables.length > 0 && (
                  <div style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 'bold', color: '#1a237e', marginBottom: 4 }}>테이블</div>
                    {progress.results.tables.map((t, i) => (
                      <div key={i} style={{ padding: '4px 10px', background: i % 2 === 0 ? '#fafafa' : 'white', fontSize: 12, display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{t.name}</span>
                        <span><span style={{ color: '#888' }}>{t.columns}컬럼</span> <span style={{ color: '#2e7d32' }}>{t.status}</span></span>
                      </div>
                    ))}
                  </div>
                )}
                {progress.results.data.length > 0 && (
                  <div style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 'bold', color: '#2e7d32', marginBottom: 4 }}>데이터 이관</div>
                    {progress.results.data.map((t, i) => (
                      <div key={i} style={{ padding: '4px 10px', background: i % 2 === 0 ? '#fafafa' : 'white', fontSize: 12, display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{t.name}</span>
                        <span style={{ color: '#2e7d32' }}>{t.rows}행 이관</span>
                      </div>
                    ))}
                  </div>
                )}
                {progress.errors.length > 0 && (
                  <div style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 'bold', color: '#c62828', marginBottom: 4 }}>오류 ({progress.errors.length}건)</div>
                    {progress.errors.map((e, i) => (
                      <div key={i} style={{ padding: '4px 10px', background: '#ffebee', borderRadius: 4, marginBottom: 2, fontSize: 11, color: '#c62828' }}>{e}</div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* 로그 */}
            <div style={{ padding: '12px 20px', borderTop: '1px solid #eee', background: '#fafafa', maxHeight: 200, overflowY: 'auto' }}>
              <div style={{ fontSize: 12, fontWeight: 'bold', color: '#888', marginBottom: 6 }}>실행 로그</div>
              {progress.log.map((l, i) => (
                <div key={i} style={{ fontSize: 11, color: l.includes('오류') ? '#c62828' : '#555', fontFamily: 'monospace', padding: '2px 0' }}>{l}</div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MigrateAgent;
